import { useMemo } from 'react';

import { AppSelectors } from 'store/App';
import { TAB_BARS_LIST, TabBarKey } from 'store/App/constants';
import { useAppSelector } from 'store/hooks';

const tabRoutes = TAB_BARS_LIST.map((tabBar) => ({ key: tabBar.value }));

export function useNavigationContext() {
  const selectedTabBar = useAppSelector(AppSelectors.selectCurrentTabBar);
  return useMemo(() => {
    let tabIndex = TAB_BARS_LIST.findIndex(
      (tabBar) => tabBar.value === selectedTabBar,
    );

    tabIndex = tabIndex >= 0 ? tabIndex : 0;

    const navigationState = { index: tabIndex, routes: tabRoutes };

    return {
      navigationState,
      activeTabIndex: tabIndex,
      activeRouteKey: tabRoutes[tabIndex]?.key,
    } as const;
  }, [selectedTabBar]);
}
